import React from 'react';
import i18next from 'i18next';
import { Navigate } from 'react-router-dom';
import { AppRouteGroup } from 'app/store/components/NavigationUtils';

import { lazyRetry } from 'app/main/components';

import TotemCommunicationSection from './sections/TotemCommunicationSection';
import TotemDocumentsSection from './sections/TotemDocumentsSection';

import en from './i18n/en';
import it from './i18n/it';

const TotemPage = lazyRetry(() => import('./TotemPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

// TODO: spostare in file separato
i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('it', 'navigation', it);

const routes: AppRouteGroup = {
	settings: {
		layout: {
			style: 'layout1',
			config: {
				navbar: {
					display: true,
					style: 'style-3',
					folded: true,
					position: 'left'
				},
				toolbar: { display: false }
			}
		}
	},
	routes: [
		{
			path: 'totem',
			auth: null,
			element: <Navigate to="/totem/communications" />
		},
		{
			path: 'totem/communications',
			auth: null,
			element: (
				<TotemPage>
					<TotemCommunicationSection />
				</TotemPage>
			)
		},
		{
			path: '/totem/documents',
			auth: null,
			element: (
				<TotemPage>
					<TotemDocumentsSection />
				</TotemPage>
			)
		}
	]
};

export default routes;
